module.exports = __webpack_public_path__ + "img/it.hoover.wizard.26e7d095.webp";